import * as S from './styles';
import { useTheme } from 'styled-components';
import { IconeChippu } from '@/components/atoms/Icones/IconeChippu';
import { CSSProperties, SetStateAction } from 'react';
import useBreakpoint from '@/hooks/useBreakpoint';

interface AvaliarChippuProps {
  onClick: (valor: SetStateAction<number>) => void;
  $avaliacao: number;
  style?: CSSProperties;
}

export default function AvaliarChippu(props: AvaliarChippuProps) {
  const { onClick, $avaliacao, style } = props;

  const theme = useTheme();
  const { breakpoint } = useBreakpoint();
  // const [avaliacao, setAvaliacao] = useState(0);

  // useEffect(() => {
  //   if ($avalicao === 0) {
  //     setAvaliacao(0);
  //   }
  // }, [$avalicao]);

  const handleAvaliacaoClick = (valor: number) => {
    if (valor - $avaliacao === 0.5) {
      // setAvaliacao(valor);
      onClick(valor);
    } else {
      // setAvaliacao(valor - 0.5);
      onClick(valor - 0.5);
    }
  };

  return (
    <S.Row
      style={{
        gap: theme.spacing[breakpoint === 'mobile' ? 1 : 4],
        ...style,
      }}
    >
      {[1, 2, 3, 4, 5].map((valor, index) => (
        <S.BotaoAvaliar key={index} onClick={() => handleAvaliacaoClick(valor)}>
          <S.IconWrapper
            style={{
              opacity: $avaliacao >= valor - 0.5 ? 1 : 0.5,
            }}
            $opacity={valor - $avaliacao === 0.5 ? 0.5 : 0}
          >
            <IconeChippu size={18} color={theme.colors.accent.accent[9]} />
          </S.IconWrapper>
        </S.BotaoAvaliar>
      ))}
    </S.Row>
  );
}
